import { Col, Dropdown, Menu, Row } from "antd";
import useBreakpoint from "antd/lib/grid/hooks/useBreakpoint";
import React from "react";
import { useTranslation } from "react-i18next";
import { useHistory } from "react-router-dom";
import { ButtonC, IconC, SelectC } from "src/shared/components";
import fileDownloader from "src/shared/function/fileDownloader";
import queryString from "src/shared/function/queryString";
import useAuth from "src/shared/hooks/useAuth";
import useDomain from "src/shared/hooks/useDomain";
import LoginIcon from "../../shared/assets/svg/icon/LoginIcon.svg";
import "./index.less";
import qs from "query-string";
import useLocalization from "src/shared/hooks/useLocalization";

const HeaderWhiteLAble = () => {
  const { t } = useTranslation();
  const { logoPath } = useDomain();
  const { xs, sm, md, lg, xl, xxl } = useBreakpoint();
  const { isLogedIn, decode, accessToken, logout } = useAuth();
  const { getLanguage, setLanguage, setCurrency, getCurrency } =
    useLocalization();

  const {
    push,
    location: { search },
  } = useHistory();

  const domainData = useDomain();

  const menu = (
    <Menu>
      <Menu.Item
        icon={<IconC type="LogoutOutlined" style={{ fontSize: "17px" }} />}
        onClick={() => {
          push({
            search: queryString({
              ...qs.parse(search),
              lol: false,
            }),
          });
          logout();
        }}
      >
        {t("logout")}
      </Menu.Item>
    </Menu>
  );

  return (
    <Row justify="space-between">
      <Col
        className="HeaderWhiteLAbleStyle"
        style={{ background: domainData?.primaryColor }}
        span={24}
      >
        <Row justify="space-between" align="middle">
          <Col>
            <Row align="middle">
              <Col>
                <img className="logo" src={fileDownloader(logoPath)} alt="" />
              </Col>
              <Col>
                <SelectC
                  showSearch
                  size="small"
                  style={{
                    width: "120px",
                    transform: "translate(0,12px)",
                    color: "#fff",
                  }}
                  bordered={false}
                  // col={{ xs: 24 }}
                  defaultValue={
                    getLanguage()?.language ||
                    // @ts-ignore
                    JSON.parse(localStorage.getItem("localization"))?.language
                  }
                  api="/localization/languages/select"
                  formItem={{
                    label: "",
                    name: "language",
                  }}
                  onChange={(e, r) => {
                    //@ts-ignore
                    setLanguage(e, r?.row?.iso639_1, r?.row?.isRtl);
                    window.location.reload();
                  }}
                />
              </Col>
              <Col>
                <SelectC
                  // showSearch
                  size="small"
                  style={{ width: "120px", transform: "translate(0,10px)" }}
                  dropdownStyle={{ verticalAlign: "-5px" }}
                  bordered={false}
                  // col={{ xs: 24 }}
                  defaultValue={getCurrency()?.currencyId}
                  api="/localization/currency/select"
                  formItem={{
                    label: "",
                    name: "currency",
                  }}
                  onChange={(e, r) => {
                    //@ts-ignore
                    setCurrency(e, r?.row?.symbol_native);
                    window.location.reload();
                  }}
                />
              </Col>
            </Row>
          </Col>

          <Col>
            {isLogedIn ? (
              <Dropdown
                overlayStyle={{
                  zIndex: 100,
                  cursor: "pointer",
                }}
                overlay={menu}
              >
                <ButtonC
                  style={{
                    background: "transparent",
                    color: "#fff",
                    borderRadius: "20px",
                    cursor: "pointer",
                  }}
                  onClick={() => {
                    push(`/panel/buyProduct`);
                    // window.location.replace("/panel/buyProduct");
                  }}
                >
                  {t("My user panel")}
                </ButtonC>
              </Dropdown>
            ) : (
              <ButtonC
                type="default"
                style={{
                  background: "transparent",
                  color: "#fff",
                  borderRadius: "20px",
                  fontSize: "14px",
                }}
                // onClick={() => window.location.replace("/panel/login")}
                onClick={() =>
                  push({
                    search: queryString({
                      ...qs.parse(search),
                      lol: true,
                    }),
                  })
                }
              >
                {xs || sm || md ? (
                  <img
                    style={{ margin: "0 0 0 5px", width: "22px" }}
                    src={LoginIcon}
                    alt=""
                  />
                ) : null}
                {t("login")} {lg || xl || xxl ? "/" : ""}{" "}
                {lg || xl || xxl ? t("register") : t("")}
              </ButtonC>
            )}
          </Col>
        </Row>
      </Col>
    </Row>
  );
};

export default HeaderWhiteLAble;
